var map = {
	"./blog-04.jpg": 1053,
	"./blog-05.jpg": 1054,
	"./blog-06.jpg": 1055,
	"./blog-07.jpg": 1056,
	"./blog-08.jpg": 1057,
	"./blog-09.jpg": 1058,
	"./blog-1.jpeg": 1059,
	"./blog-2.jpeg": 1060,
	"./blog-3.jpg": 1061
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/posts ^\.\/.*$
// module id = 570
// module chunks = 1